import React from "react";
var __jsx = React.createElement;
import { useTranslation } from "react-i18next";
import { UnstyledButton } from "@mantine/core";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCheck, faXmark, faCommentSms, faRotateRight } from "@fortawesome/pro-regular-svg-icons";
import { SmsStatusCode } from "@/types/sms";
import { getStatusMeta } from "@/utils/sms";
import { formatDateTime } from "@/utils/format";
import { SMS_PILL_CLASSES, SMS_DOT_CLASSES, SMS_RING_CLASSES } from "./sms-pill-styles";
/** A single SMS history row: status ring, template, timestamp, retry, pill. */
export function SmsMessageCard(_ref) {
  var message = _ref.message,
    templateName = _ref.templateName,
    onRetry = _ref.onRetry,
    isRetrying = _ref.isRetrying;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var meta = getStatusMeta(message.status, message.status_label);
  var canRetry = message.status === SmsStatusCode.FAILED;
  var ringIcon = meta.pill === "viewed" || meta.pill === "delivered" ? faCheck : meta.pill === "failed" ? faXmark : faCommentSms;
  return /*#__PURE__*/React.createElement("div", {
    className: "flex items-center gap-3 rounded-sds-200 border border-sds-base-default bg-sds-base-default p-3"
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex h-7 w-7 flex-shrink-0 items-center justify-center rounded-sds-full ".concat(SMS_RING_CLASSES[meta.pill])
  }, /*#__PURE__*/React.createElement(FontAwesomeIcon, {
    icon: ringIcon,
    className: "h-4 w-4"
  })), /*#__PURE__*/React.createElement("div", {
    className: "flex min-w-0 flex-1 flex-col"
  }, /*#__PURE__*/React.createElement("p", {
    className: "truncate text-style-body-small-strong text-sds-base-default"
  }, templateName), /*#__PURE__*/React.createElement("p", {
    className: "text-style-label-base text-sds-base-tertiary"
  }, formatDateTime(message.created_at || message.queued_at)), canRetry ? /*#__PURE__*/React.createElement(UnstyledButton, {
    "data-testid": "sms-message-retry-".concat(message.id),
    disabled: isRetrying,
    onClick: function onClick() {
      return onRetry(message.id);
    },
    className: "mt-1 flex items-center gap-1 text-style-label-base text-sds-urgent-default hover:underline disabled:opacity-60"
  }, /*#__PURE__*/React.createElement(FontAwesomeIcon, {
    icon: faRotateRight,
    className: "h-3 w-3"
  }), isRetrying ? t("sms.history.retrying", {
    defaultValue: "Retrying…"
  }) : t("sms.history.retry", {
    defaultValue: "Retry"
  }), message.failure_reason ? " \xB7 ".concat(message.failure_reason) : "") : null), /*#__PURE__*/React.createElement("span", {
    className: "inline-flex flex-shrink-0 items-center gap-1.5 rounded-sds-full px-4 py-2 text-style-label-strong leading-none ".concat(SMS_PILL_CLASSES[meta.pill])
  }, /*#__PURE__*/React.createElement("span", {
    className: "h-2 w-2 flex-shrink-0 rounded-sds-full ".concat(SMS_DOT_CLASSES[meta.pill])
  }), meta.label));
}